import { useMemo } from 'react';

// Icons
import InWay from '../../../icons/orderStatus/in-way.svg';
import Prepared from '../../../icons/orderStatus/prepared.svg';
import Delivered from '../../../icons/orderStatus/delivered.svg';
import Taken from '../../../icons/orderStatus/taken.svg';
import Ready from '../../../icons/orderStatus/ready.svg';

export default function useSteps(props) {
  const {
    orderData: { order_status, delivery_type },
  } = props;

  const statuses = useMemo(() => {
    // нулевой статус показываем как первый
    const currentStatus = Number(order_status) === 0 ? 1 : Number(order_status);

    const allStatuses =
      delivery_type !== 'pickup'
        ? [
            { id: 1, text: 'orderStatus.status.taken', icon: Taken },
            { id: 2, text: 'orderStatus.status.prepared', icon: Prepared },
            { id: 4, text: 'orderStatus.status.inWay', icon: InWay },
            { id: 5, text: 'orderStatus.status.delivered', icon: Delivered },
          ]
        : [
            { id: 1, text: 'orderStatus.status.taken', icon: Taken },
            { id: 2, text: 'orderStatus.status.prepared', icon: Prepared },
            { id: 3, text: 'orderStatus.status.ready', icon: Ready },
          ];

    return allStatuses.map(status => ({
      ...status,
      isPrevious: status.id < currentStatus,
      isActive: status.id === currentStatus,
    }));
  }, [order_status, delivery_type]);

  return { statuses };
}
